module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("设置必经点\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pointData,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "serialNum",
      "label": "点位编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pointsDesc",
      "label": "点位名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "必经点位"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('el-switch', {
            attrs: {
              "active-color": "#13ce66",
              "inactive-color": "#ff4949"
            },
            model: {
              value: (_vm.row.setMustThough),
              callback: function($$v) {
                _vm.$set(_vm.row, "setMustThough", $$v)
              },
              expression: "row.setMustThough"
            }
          })
        
      },
      staticRenderFns: []
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-99c1c61a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiaoyuan/GX/setMustPoint.vue
// module id = 1106
// module chunks = 0